import React, {useState} from 'react'

export const Divider = (props) => (
    <div className="divider mb-4 mt-4" ></div>
)